import process from 'process'

var config = {
  apiUrl: 'https://pl3api.amiranplus.ir/api/v1/',
  clientUrl: 'https://pl3api.amiranplus.ir/api/v1/',
  uploadsUrl: 'https://pl3api.amiranplus.ir/'
}

// config = {
//   apiUrl: 'https://localhost:44366/api/v1/',
//   clientUrl: 'https://localhost:44366/api/v1/',
//   uploadsUrl: 'https://localhost:44366/'
// }

export default config
